// In-page links should release Dawn's drawer and focus trap before scrolling.
document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, location.href);
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
  const drawer = link.closest('header-drawer');
  const toggle = drawer.querySelector('summary');
  if (typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, toggle);
    toggle.setAttribute('aria-expanded', 'false');
  }
});
